import React from "react";
export function SaftiLogo({
  light = false
}: {
  light?: boolean;
}) {
  return <span className="flex items-center gap-2" aria-label="SAFTI" data-id="element-198" data-mp="3ith9p3w15qgu">
      <svg width="30" height="28" viewBox="0 0 30 28" aria-hidden="true" data-id="element-199" data-mp="3iv21ilqymvb0">
        <path d="M15 1 L29 11 V27 H1 V11 Z" fill="#F26522" data-id="element-200" data-mp="1diwb8u4syzv" />
        <path d="M10 27 V16 H20 V27" fill={light ? "#151413" : "#FAF8F5"} data-id="element-201" data-mp="3sronjdv0vsem" />
      </svg>
      <span className={`text-[22px] font-semibold tracking-[0.18em] ${light ? "text-white" : "text-brand"}`} data-id="element-202" data-mp="adfdkpe6yvkw">SAFTI</span>
    </span>;
}